import React, {Component} from 'react';
import { Table } from 'antd';
import config from 'src/commons/config-hoc';
import {ModalContent} from 'src/library/components';
import './index.less'

@config({
    ajax: true,
    modal: {
        title: props => props.titleName,
    },
})
export default class EditModal extends Component {
    state = {
        loading: false, // 页面加载loading
        columns: [
            {
                title: '序号',
                dataIndex: 'seq',
                width: 60,
                align: 'center',
                render: (text) => {
                    return <div> {text} </div>
                }
            },
            {
                title: '详情信息',
                dataIndex: 'msg',
                align: 'center',
                render: (text) => {
                    return <div style={{ textAlign: 'left' }}> {text} </div>
                }
            },
        ],
    };

    componentDidMount() {

    }
    render() {
        const { loading, columns } = this.state;
        let { infoData } = this.props
        return (
            <ModalContent
                loading={loading}
                bodyStyle={{padding: 16}}
                okText={ null }
                cancelText="取消"
                onCancel={() => this.props.onCancel()}
            >
                <div style={{ height: 550 }}>
                    <Table
                        columns={columns}
                        dataSource={infoData}
                        pagination={false}
                        scroll={{ y: 509 }}
                        rowKey="id"
                        bordered
                    />
                </div>
            </ModalContent>
        );
    }
}
